import { useEffect } from "react";
import { AppProviders } from "./app/providers";
import { useAppSelector } from "./app/hooks";
import { OfflineBar } from "@features/navigation/components/offline-bar";
import { useIdentityCheck } from "@features/auth/model/use-identity-check";
import { useSessionProfile } from "@features/auth/model/use-session-profile";
import { syncInboxSession } from "@features/inbox/lib/inbox-handoff";
import { AppRoutes } from "./routes";

export function App() {
  return (
    <AppProviders>
      <AppShell />
    </AppProviders>
  );
}

/**
 * ข้างในสุดของ provider — hook ที่ต้องใช้ store/query ต้องอยู่ที่นี่ ไม่ใช่ใน App
 * (App เป็นตัวสร้าง provider เอง จึงยังไม่มี context ให้ใช้)
 */
function AppShell() {
  useSessionProfile();
  useIdentityCheck();
  const session = useAppSelector((s) => s.session.current);

  // Inbox Center ที่ฝังเป็น iframe อ่าน session จากที่เก็บคนละที่กับเรา — คัดลอกให้ตรงกัน
  // ทุกครั้งที่ session เปลี่ยน (login / โปรไฟล์มาถึง / logout) ดู inbox-handoff.ts
  useEffect(() => {
    syncInboxSession(session);
  }, [session]);

  return (
    <>
      <AppRoutes />
      {/* อยู่นอก routes เพราะต้องเห็นทุกหน้า */}
      <OfflineBar />
    </>
  );
}
